/**
 * 用户相关类型定义
 */

/**
 * 用户基本信息
 */
export interface User {
  id: string
  name: string
  /** 登录用户名/账号名，展示时优先用于避免把用户 ID 当名称显示 */
  username?: string
  email: string
  avatar?: string
  role?: string
  /** 用户角色列表（从 JWT payload 中解析） */
  roles?: string[]
  permissions?: string[]
  createdAt?: string
  updatedAt?: string
  /** 用户所属项目ID（从统一用户平台透传） */
  projectId?: string
  /** 租户ID（可选，用于多租户场景） */
  tenantId?: string
}

export type PermissionCode = string

export interface MePermissionsResponse {
  roles: string[]
  permissions: PermissionCode[]
  menu_keys: PermissionCode[]
}

export function normalizeRole(role: string): string {
  return role.trim().toLowerCase()
}

/** 管理员角色标识 */
export const ADMIN_ROLES: ReadonlySet<string> = new Set(['admin', 'super_admin'])

/**
 * 用户资料
 */
export interface UserProfile extends User {
  phone?: string
  department?: string
  position?: string
  bio?: string
}

/**
 * 用户登录请求（username 字段承载邮箱账号，保留字段名兼容现有 API）
 */
export interface PasswordLoginRequest {
  username: string
  password: string
}

/** 手机号验证码登录（login-options 的 loginMethods 含 captcha 时可用） */
export interface CaptchaLoginRequest {
  login_type: 'captcha'
  phone: string
  captcha: string
}

/** 口令登录后的动态码第二步（口令登录回包 mfaRequired 时用）；验证与首次绑定后的确认都走这一步 */
export interface OtpLoginRequest {
  login_type: 'otp'
  mfa_ticket: string
  otp_code: string
}

export type LoginRequest = PasswordLoginRequest | CaptchaLoginRequest | OtpLoginRequest

/** 口令正确但需要动态码：enrollRequired 为首次绑定，带二维码与密钥 */
export interface MfaChallenge {
  enrollRequired: boolean
  mfaTicket: string
  otpauthUrl: string | null
  qrcodeBase64: string | null
  otpSecret: string | null
}

/**
 * 用户登录响应
 */
export interface LoginResponse {
  token: string
  refreshToken: string
  user: User
  expiresIn: number
}
